import React from "react";
import networkError from "../assets/error-screens/network_error.svg";
import { useTranslation } from "react-i18next";
import "./no_data_found.css";
import { Icon } from "pepsico-ds";

const NetworkError = ({handleRefresh, className=""}) => {
    const { t, i18n } = useTranslation();
    return (
        <div className={`${className} no-data-found-container d-flex justify-content-center`}>
            <div className="no-data-found-content">
                <div className="w-100"><img src={networkError} alt="network error" className="mx-auto d-block"/></div>
                <div className="no-data-found-main-heading">{t('auditRequest.network_error_label')}</div>
                <div className="no-data-found-sub-heading">{t('auditRequest.network_error_sub_label')}</div>
                <button className="request-button w-auto mx-auto" onClick={() => handleRefresh()}>
                    <Icon
                        alt="Retry"
                        icon="refresh"
                        size="small"
                        style={{ marginRight: '4px' }}
                    />
                    <span>{t("auditRequest.retry")}</span>
                </button>
            </div>
        </div>
    );
};
export default NetworkError;